import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reset } from '../redux/app';
import { resetCarpet } from '../redux/carpet';
import { resetUserData, setUserData } from '../redux/member';
import { resetMoodData } from '../redux/mood';
import { resetSignupData } from '../redux/signup';
import { resetSignupQuestions } from '../redux/signupQuestions';
import { freezAccount } from '../services/accountService';
import account from '../services/accountService';
import { RootState } from '../redux/store';
import { useHistory } from 'react-router-dom';
import { ONBORADING_SCREEN } from '../navigation/Constants';
import { deleteMemberPushToken } from '../services/memberService';

const FreezedAccount = (props: any) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { hubConnection } = useSelector((state: RootState) => state.app);
    const member = useSelector((state: RootState) => state.member);

    const clearReduxStoreDate = () => {
        dispatch(resetUserData());
        dispatch(resetMoodData());
        dispatch(reset());
        dispatch(resetSignupQuestions());
        dispatch(resetSignupData());
        dispatch(resetCarpet());

    };

    const logout = () => {
        if (window.platform === 'android' || window.platform === 'ios') {
            deleteMemberPushToken(member.memberCode);
        }
        account.logout();
        clearReduxStoreDate();
        hubConnection?.invoke("connectionClosed", props.member.memberCode);
        hubConnection?.stop();
        history.replace(ONBORADING_SCREEN);
    };

    const handleUnfreezAccount = async () => {
        const { data } = await freezAccount(props.member.memberCode);
        dispatch(setUserData({ ...data, isFreezedAccount: data.isFreezedAccount }))
    }

    if (!props.member.isFreezedAccount) return props.children
    else return (
        <div className="content_sec white wf-section" style={{ height: '100vh' }}>
            <div className="signup_top_info">
                <div className="signup_pict failure">
                    <img src="/assets/images/failure_pict.svg" />
                </div>
                <h2 className="signup_title welcome"> אוקיי, החשבון שלך מוקפא!</h2>
                <div>אפשר בכל רגע להוציא אותו מהפריזר ולחזור להכיר. אפילו עכשיו :) </div>
                <a href="#" onClick={handleUnfreezAccount} className="button_full welcome w-button">ביטול הקפאה</a>
                <a href="#" className="edit_info_link red w-inline-block" onClick={logout}>
                    <div className="edit_link_info">
                        <h4 className="settink_link_title">התנתקות</h4>
                    </div>
                </a>
            </div>
        </div>
    )
}

export default FreezedAccount;